// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"502":"dec4c112","1144":"3db5fcb7","6914":"3db5fcb7","7639":"a7ebee64","8693":"3e2311e8"}[chunkId] + ".chunk.css";
};